import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { routes } from './app.routes';
import { ICONS } from './icons-provider';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { getOauthModuleConfig } from './authentication/auth.config';
import { AuthenticationService } from './authentication/authentication.service';
import { environment } from '../environments/environment';
import { version } from '../environments/version';
import { GlobalErrorHandler } from './error/global-error-handler';

registerLocaleData(en);
// Sentry initialization
Sentry.init({
  dsn: 'https://898a5dcc7cf8829e7289a11be8be91b4@o1165475.ingest.us.sentry.io/4511593761013760',
  environment: environment.production ? 'production' : 'development',
  denyUrls: ['localhost:4200'],
  normalizeDepth: 5,
  release: version,
});

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideAnimations(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideOAuthClient(getOauthModuleConfig(environment)),
    provideHttpClient(withInterceptorsFromDi()),
    provideNzI18n(en_US),
    provideNzIcons(ICONS),
    provideAppInitializer(() => {
      const auth = inject(AuthenticationService);
      return auth.initialize();
    }),
  ],
};
